var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#343F74"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_667_11060",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.57129,
    y: 4.57422,
    width: 22.8571,
    height: 22.8571,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_667_11060)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.9993,
    cy: 9.57254,
    r: 2.14286,
    stroke: "#4ED5D2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.9993,
    cy: 22.428,
    r: 2.14286,
    stroke: "#4ED5D2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.9993,
    cy: 16.0022,
    r: 2.14286,
    stroke: "#4ED5D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1426 15.0476L19.5711 11",
    stroke: "#4ED5D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4277 17.4288L18.8563 21.2383",
    stroke: "#4ED5D2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsShare);
export default __webpack_public_path__ + "static/media/newsShare.8cf652dffe717ceb364dc2037c048169.svg";
export { ForwardRef as ReactComponent };